import AutoplayController from "~/lib/autoplay_controller"
import { replay } from "~/lib/motion"

// The bundle discount appears on the product page, the cursor adds the bundle
export default class extends AutoplayController {
  static targets = ["offer", "button", "count", "toast"]

  reset() {
    this.offerTarget.classList.remove("is-applied")
    this.countTarget.textContent = "0"
    this.toastTarget.hidden = true
  }

  async play(wait) {
    await wait(700)
    this.offerTarget.classList.add("is-applied")
    await wait(900)
    await this.click(this.buttonTarget, wait)
    this.countTarget.textContent = "2"
    replay(this.countTarget, "is-bump")
    this.toastTarget.hidden = false
    replay(this.toastTarget, "is-pop")
  }
}
